import { forOwn, isArray, isObject, isString, merge } from "lodash";

import { parseLocalStorageObj } from "@/Utils";

export const getMappedName = (word) => {
  const mappingJson = parseLocalStorageObj("mapping");
  return mappingJson[word];
};

export const getMappedGeo = (word) => {
  const mappingJson = parseLocalStorageObj("geoMapping");
  return mappingJson[word];
};

export const toMappedName = (word) => {
  const mappingJson = parseLocalStorageObj("mapping");
  return (
    mappingJson[word] ||
    // TODO: Evaluate if a good idea
    word
      .split("_")
      .map((w) => mappingJson[w] || w)
      .join("_")
  );
};

export const mapping = (obj) => {
  if (isString(obj)) {
    return toMappedName(obj);
  }
  if (isArray(obj)) {
    return obj.map((element, _) => mapping(element));
  }
  if (isObject(obj)) {
    let newObj = {};
    forOwn(obj, (value, key) => {
      newObj[toMappedName(key)] = mapping(value);
    });
    return newObj;
  }
  return obj;
};

export const mappingDashboard = (str) => {
  try {
    const mappingJson = parseLocalStorageObj("mapping");
    return str
      .split(" ")
      .map((item) => mappingJson[item] || item)
      .join(" - ");
  } catch (error) {
    return str;
  }
};

/**
 *
 * @returns
 * @param item
 */
export const getMappingItem = (item) => {
  try {
    const mappingJson = parseLocalStorageObj("mapping");
    return mappingJson[item] || item;
  } catch (error) {
    return item;
  }
};

export const handleConfigMapping = (obj) => {
  let result = {};
  try {
    result = merge(obj.other, obj.meta);
    localStorage.setItem("mapping", JSON.stringify(result));
    localStorage.setItem("geoMapping", JSON.stringify(obj.geography));
    return result;
  } catch (error) {
    return result;
  }
};
